import { UnfilteredConditionalArray } from './types';
import {
  ApplicationConditionalContext,
  useApplicationConditionalContext,
} from './useApplicationConditionalContext';
import { useConditionalFilter } from './useConditionalFilter';

export const useApplicationConditionalFilter = <V>(
  unfilteredValues: UnfilteredConditionalArray<
    ApplicationConditionalContext,
    V
  >,
) => {
  const context = useApplicationConditionalContext();

  return useConditionalFilter<ApplicationConditionalContext, V>(
    context,
    unfilteredValues,
  );
};
